(function () {
  // Keep this catalogue aligned with the live product configurators. See
  // docs/shaft-library-maintenance.md for the safe update and QA checklist.
  const GA4_MEASUREMENT_ID = 'G-77KS9BZNPN';
  const CATALOG = {
    driver: [
      ['Project X', 'HZRDUS Gen4 Black 60', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'HZRDUS Gen4 Black 70', 'stock', ['Stiff', 'X-Stiff']],
      ['Project X', 'Denali Blue 50', 'stock', ['Senior', 'Regular', 'Stiff']],
      ['Project X', 'Denali Blue 60', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'Denali Black 60', 'stock', ['Stiff', 'X-Stiff']],
      ['Project X', 'Cypher 2.0', 'stock', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Fujikura', 'Vista Pro 45', 'stock', ['Ladies', 'Senior', 'Regular']],
      ['Fujikura', 'Vista Pro 55', 'stock', ['Senior', 'Regular', 'Stiff']],
      ['Fujikura', 'Vista Pro 65', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Red Velocore 5', 'upcharge', ['Senior', 'Regular', 'Stiff']],
      ['Fujikura', 'Ventus TR Red Velocore 6', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Blue Velocore 6', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Blue Velocore 7', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Black Velocore 6', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Black Velocore 7', 'upcharge', ['Stiff', 'X-Stiff']]
    ],
    fairway: [
      ['Project X', 'HZRDUS Gen4 Black 70', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'HZRDUS Gen4 Black 80', 'stock', ['Stiff', 'X-Stiff']],
      ['Project X', 'Denali Blue 60', 'stock', ['Regular', 'Stiff']],
      ['Project X', 'Denali Blue 70', 'stock', ['Stiff', 'X-Stiff']],
      ['Project X', 'Denali Black 70', 'stock', ['Stiff', 'X-Stiff']],
      ['Project X', 'Cypher 2.0', 'stock', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Fujikura', 'Vista Pro 45', 'stock', ['Ladies']],
      ['Fujikura', 'Vista Pro 55', 'stock', ['Senior', 'Regular']],
      ['Fujikura', 'Vista Pro 65', 'stock', ['Stiff']],
      ['Fujikura', 'Vista Pro 75', 'stock', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Red Velocore 7', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Red Velocore 8', 'upcharge', ['X-Stiff']],
      ['Fujikura', 'Ventus TR Blue Velocore 7', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Blue Velocore 8', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus TR Black Velocore 7', 'upcharge', ['Stiff']],
      ['Fujikura', 'Ventus TR Black Velocore 8', 'upcharge', ['X-Stiff']]
    ],
    hybrid: [
      ['Project X', 'Cypher 2.0', 'stock', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Project X', 'HZRDUS Gen4 Black 80', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'HZRDUS Gen4 Black 90', 'stock', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Vista Pro 40', 'stock', ['Ladies']],
      ['Fujikura', 'Vista Pro 50', 'stock', ['Senior']],
      ['Fujikura', 'Vista Pro 60', 'stock', ['Regular', 'Stiff']],
      ['Fujikura', 'Vista Pro 70', 'stock', ['Stiff']],
      ['Fujikura', 'Ventus Blue HB Velocore 8', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus Blue HB Velocore 9', 'upcharge', ['X-Stiff']],
      ['Fujikura', 'Ventus Black HB Velocore 9', 'upcharge', ['X-Stiff']],
      ['Aerotech', 'HLS 780', 'upcharge', ['Senior', 'Regular', 'Stiff']],
      ['Aerotech', 'HLS 880', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Mitsubishi', 'MMT Hybrid 70', 'upcharge', ['Senior', 'Regular']],
      ['Mitsubishi', 'MMT Hybrid 80', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Mitsubishi', 'MMT Hybrid 90', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Nippon', 'N.S. Modus3 Hybrid (Custom Order)', 'upcharge', ['Stiff', 'X-Stiff']]
    ],
    driving_iron: [
      ['True Temper', 'Dynamic Gold', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold Tour Issue', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Aerotech', 'SteelFiber HLS 780', 'upcharge', ['Senior', 'Regular', 'Stiff']],
      ['Project X', 'Cypher 2.0', 'stock', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Project X', 'HZRDUS Gen4 Black 80', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'Project X U', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'Project X LS', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Fujikura', 'Ventus HB Blue Velocore 6R2', 'upcharge', ['Senior']],
      ['Fujikura', 'Ventus HB Blue Velocore 7R', 'upcharge', ['Regular']],
      ['Fujikura', 'Ventus HB Blue Velocore 8S', 'upcharge', ['Stiff']],
      ['Fujikura', 'Ventus HB Blue Velocore 9X', 'upcharge', ['X-Stiff']],
      ['Fujikura', 'Ventus HB Black Velocore 9X', 'upcharge', ['X-Stiff']],
      ['Nippon', 'N.S. Modus3 Hybrid (Custom Order)', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Mitsubishi', 'MMT Hybrid 70', 'upcharge', ['Senior', 'Regular']],
      ['Mitsubishi', 'MMT Hybrid 80', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Mitsubishi', 'MMT Hybrid 90', 'upcharge', ['Stiff', 'X-Stiff']]
    ],
    iron: [
      ['True Temper', 'Dynamic Gold', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Elevate 85 Black', 'stock', ['Regular', 'Stiff']],
      ['True Temper', 'Dynamic Gold 105', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold 120', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold Tour Issue 120 (Custom Order)', 'upcharge', ['Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold Mid 115', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold Tour Issue', 'upcharge', ['Stiff', 'X-Stiff']],
      ['KBS', 'Tour', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['KBS', 'Tour Lite', 'stock', ['Regular', 'Stiff']],
      ['KBS', 'Max 80', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['KBS', 'C-Taper Lite (Custom Order)', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['KBS', 'Custom Black Tour', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['KBS', 'Max Graphite', 'upcharge', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['KBS', 'TGI Tour Graphite', 'upcharge', ['Ladies', 'Senior', 'Regular', 'Stiff', 'X-Stiff']],
      ['Aerotech', 'SteelFiber i70', 'upcharge', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Aerotech', 'SteelFiber i80', 'upcharge', ['Ladies', 'Senior', 'Regular', 'Stiff', 'X-Stiff']],
      ['Aerotech', 'SteelFiber i95', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Aerotech', 'SteelFiber i110', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Aerotech', 'SteelFiber i125', 'upcharge', ['Stiff', 'X-Stiff']],
      ['Project X', 'Project X', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Project X', 'Cypher 2.0', 'stock', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Project X', 'Project X LZ (Custom Order)', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Recoil', 'DART 55', 'stock', ['Ladies']],
      ['Recoil', 'DART 65', 'stock', ['Senior', 'Regular']],
      ['Recoil', 'DART 75', 'stock', ['Stiff']],
      ['Nippon', 'N.S. Pro Modus 3 105 (Custom Order)', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Nippon', 'N.S. Pro Modus 3 120 (Custom Order)', 'upcharge', ['Stiff', 'X-Stiff']]
    ],
    wedge: [
      ['True Temper', 'Dynamic Gold', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold Mid 115', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['True Temper', 'Elevate 85 Black', 'stock', ['Regular', 'Stiff']],
      ['True Temper', 'Dynamic Gold Tour Issue', 'upcharge', ['Stiff', 'X-Stiff']],
      ['True Temper', 'Dynamic Gold Tour Issue Onyx', 'upcharge', ['Stiff', 'X-Stiff']],
      ['KBS', 'Hi-Rev 2.0', 'stock', ['Regular', 'Stiff', 'X-Stiff']],
      ['KBS', 'Tour Lite', 'stock', ['Regular', 'Stiff']],
      ['KBS', 'Custom Black Tour', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Nippon', 'N.S. Pro Modus Wedge', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']],
      ['Recoil', 'DART 55', 'stock', ['Ladies']],
      ['Recoil', 'DART 65', 'stock', ['Senior', 'Regular']],
      ['Recoil', 'DART 75', 'stock', ['Stiff']],
      ['Project X', 'Cypher 2.0', 'stock', ['Ladies', 'Senior', 'Regular', 'Stiff']],
      ['Project X', 'Project X Wedge', 'upcharge', ['Regular', 'Stiff', 'X-Stiff']]
    ]
  };

  const CATEGORY_LABELS = {
    driver: 'Driver',
    fairway: 'Fairway wood',
    hybrid: 'Hybrid',
    driving_iron: 'Driving iron',
    iron: 'Iron',
    wedge: 'Wedge'
  };

  const allShafts = Object.entries(CATALOG).flatMap(([category, rows]) => rows.map(([brand, model, status, flexes]) => ({
    category,
    brand,
    model,
    status,
    flexes
  })));

  const SHAFT_IMAGES = [
    [/hzrdus gen4 black/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/HZRDUS_G4Black_45.png?v=1773767077'],
    [/denali blue/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/px_denali_blue_45.png?v=1775080914'],
    [/denali black/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/px_denali_black_45.png?v=1775080939'],
    [/cypher 2\.0/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/Cypher_2.0_45.png?v=1773702373'],
    [/ventus tr red/i, 'https://fujikuragolf.com/wp-content/uploads/2024/05/fujikura-ventus-tr-red-scaled.jpeg'],
    [/ventus tr blue/i, 'https://fujikuragolf.com/wp-content/uploads/2024/05/fujikura-ventus-tr-blue-scaled.jpeg'],
    [/ventus tr black/i, 'https://fujikuragolf.com/wp-content/uploads/2024/05/fujikura-ventus-tr-black-scaled.jpeg'],
    [/ventus (?:blue hb|hb blue)/i, 'https://fujikuragolf.com/wp-content/uploads/2025/01/VENTUS-HB-Blue-Bend-profile.jpg'],
    [/ventus (?:black hb|hb black)/i, 'https://fujikuragolf.com/wp-content/uploads/2024/12/VENTUS-HB-Black-scaled.jpg'],
    [/vista pro/i, 'https://fujikuragolf.com/wp-content/uploads/2024/05/fujikura-vista-pro-hero-wood.png'],
    [/hls 780/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/sf_hls_780_45.png?v=1773697738'],
    [/hls 880/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/sf_hls_880_45.png?v=1773697686'],
    [/steelfiber i\d+/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/sf_i70_cw_45_62342903-bf59-4e09-a1b0-9c1bf07505c0.png?v=1777921396'],
    [/mmt hybrid/i, 'https://mitsubishigolf.com/cdn/shop/files/MCA-MCA_Main-Shaft-MMT-Hybrid-v1.1.png?v=1689313293'],
    [/modus3 hybrid/i, 'https://nipponshaft.com/assets/img/product/graphite/modus_hybrid/item_01_pc.jpg'],
    [/modus 3 105/i, 'https://nipponshaft.com/assets/img/product/steel/modus_105/items_01_pc.jpg'],
    [/modus 3 120/i, 'https://nipponshaft.com/assets/img/product/steel/modus_120/items_pc.jpg'],
    [/modus wedge/i, 'https://nipponshaft.com/assets/img/product/steel/modus_wedge/items_02_pc.jpg'],
    [/dynamic gold tour issue onyx/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/DGTI_S400_PCB_45.png?v=1787595883'],
    [/dynamic gold tour issue 120/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_dg120_ti_45.png?v=1774302537'],
    [/dynamic gold tour issue/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_dg_ti_45.png?v=1773767693'],
    [/dynamic gold mid 115/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_dg_mid_115_45.png?v=1773768010'],
    [/dynamic gold 105/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_dg_105_nottourissue_45.png?v=1773768293'],
    [/dynamic gold 120/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_dg_120_45.png?v=1773767754'],
    [/dynamic gold/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_dg_cigar_45.png?v=1773767223'],
    [/elevate 85 black/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/tt_elevate_black_45.png?v=1773767031'],
    [/project x wedge/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/PX_Wedge_45.png?v=1773767189'],
    [/project x lz/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/PX_LZ_45.png?v=1773767733'],
    [/project x u/i, 'https://vingolf.com.my/cdn/shop/files/Project_X_-_Utility_Iron_0.370.jpg?v=1723985754'],
    [/project x ls/i, 'https://fairwaygolfusa.shop/cdn/shop/files/TRT0074_1200x1200.jpg?v=1750284021'],
    [/project x$/i, 'https://cdn.shopify.com/s/files/1/0731/4063/3771/files/PX_Steel_45.png?v=1773767833'],
    [/kbs custom black tour/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/KBS_PhotosForSocial_CustomTourSeries_BlackWhite-2-scaled_cf7dae0c-d97a-4d24-a682-8be0e3cfa7a6.jpg?v=1722439921'],
    [/kbs c-taper lite/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_c_taper_lite_r_d.png?v=1722446225'],
    [/kbs tour lite/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_tourLite_95_d.webp?v=1722533908'],
    [/kbs max 80/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_max_80_r_d.png?v=1722445597'],
    [/kbs max graphite/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_max_graphite_45_d_6b63afa7-ad28-45a7-9a3b-22385673753b.webp?v=1722449208'],
    [/kbs tgi tour graphite/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_iron_graphite_60_d.webp?v=1722449067'],
    [/kbs hi-rev 2\.0/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_hi_rev_2.webp?v=1722446776'],
    [/kbs tour/i, 'https://cdn.shopify.com/s/files/1/0651/8102/4452/files/kbs_tour_120_s_d.png?v=1722533862'],
    [/recoil dart/i, 'https://www.ustmamiya.com/wp-content/uploads/UST-Mamiya-Recoil-DART-BlkIP.jpg']
  ];

  function imageFor(item) {
    const name = `${item.brand} ${item.model}`;
    const match = SHAFT_IMAGES.find(([pattern]) => pattern.test(name));
    return match ? match[1] : '';
  }

  function profileFor(item) {
    const name = `${item.brand} ${item.model}`.toLowerCase();
    if (/hzrdus.*black|denali black|ventus.*black|project x ls|dynamic gold(?! mid)|project x$/.test(name)) return { launch: 'Low', spin: 'Low', feel: 'Firm / stable' };
    if (/cypher|vista pro 4|vista pro 5|max 80|max graphite|tour lite|elevate|hi-rev/.test(name)) return { launch: 'High', spin: 'Mid-high', feel: 'Lighter / active' };
    if (/ventus.*red|c-taper lite|steelfiber i70/.test(name)) return { launch: 'Mid-high', spin: 'Mid', feel: 'Responsive / stable' };
    if (/ventus.*blue|denali blue|dynamic gold mid|project x lz|dart|mmt|hls|modus|kbs tour|steelfiber/.test(name)) return { launch: 'Mid', spin: 'Mid', feel: 'Balanced / stable' };
    return { launch: 'Mid', spin: 'Mid', feel: 'Balanced' };
  }

  function materialFor(item) {
    const name = `${item.brand} ${item.model}`.toLowerCase();
    if (/steelfiber|modus3 hybrid/.test(name)) return 'Composite';
    if (/cypher|recoil|dart|ventus|vista|denali|hzrdus|mmt|max graphite|tgi|project x u/.test(name)) return 'Graphite';
    if (['driver', 'fairway', 'hybrid'].includes(item.category)) return 'Graphite';
    return 'Steel';
  }

  function weightFor(item) {
    const name = item.model.toLowerCase();
    const ranges = [
      [/cypher/, '45–55 g'],
      [/ventus.*(?:velocore\s*)?([5-9])(?:r2|r|s|x)?\b/, (match) => `${Number(match[1]) * 10} g class`],
      [/hls 780/, '85 g class'],
      [/hls 880/, '95 g class'],
      [/elevate 85/, '85 g class'],
      [/hi-rev 2\.0/, '115–135 g'],
      [/dynamic gold tour issue 120/, '116–120 g'],
      [/dynamic gold tour issue/, '130–132 g'],
      [/dynamic gold mid 115/, '115 g'],
      [/dynamic gold 105/, '103–105 g'],
      [/dynamic gold 120/, '116–120 g'],
      [/dynamic gold$/, '127–130 g'],
      [/^tour$|custom black tour/, '110–130 g'],
      [/tour lite/, '95–100 g'],
      [/max 80/, '80 g'],
      [/c-taper lite/, '105–115 g'],
      [/max graphite/, '45–85 g'],
      [/tgi tour graphite/, '50–90 g'],
      [/project x lz/, '110–120 g'],
      [/project x wedge|project x$/, '115–125 g'],
      [/project x u/, '90 g class'],
      [/project x ls/, '120–125 g'],
      [/modus3 hybrid/, '89–90 g'],
      [/modus 3 105/, '105 g class'],
      [/modus 3 120/, '120 g class'],
      [/modus wedge/, '111–133 g']
    ];
    const match = ranges.find(([pattern]) => pattern.test(name));
    if (match) {
      const result = name.match(match[0]);
      return typeof match[1] === 'function' ? match[1](result) : match[1];
    }
    const number = name.match(/(?:black|blue|red|pro|velocore|hybrid|hls|i|dart|mmt)\s*(\d{2,3})/i)?.[1];
    return number ? `${number} g class` : 'Varies by flex';
  }

  function whyFor(item, profile, material) {
    if (material === 'Composite') return 'Adds a lower-vibration option while retaining the stable response many players expect from a structured profile.';
    if (profile.launch === 'High') return 'Gives the Haywood lineup an easier-launching, generally lighter option at this point in the build.';
    if (profile.launch === 'Low') return 'Provides a firmer, lower-flight option for golfers who value stability and a more controlled delivery.';
    if (item.status === 'upcharge') return 'Extends the standard range with a distinct premium profile for golfers who already know the feel or flight they prefer.';
    return 'Creates a balanced reference point between specialized higher- and lower-flight profiles.';
  }

  function maySuit(profile) {
    if (profile.launch === 'High') return 'May suit smoother tempos or golfers looking for easier launch and a more active feel.';
    if (profile.launch === 'Low') return 'May suit stronger or more assertive transitions seeking a stable feel and more penetrating flight.';
    if (profile.launch === 'Mid-high') return 'May suit golfers looking for added height without moving to the lightest or softest profile.';
    return 'May suit golfers who prefer a balanced blend of feel, stability and flight.';
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    }[character]));
  }

  const SEARCH_STOP_WORDS = new Set([
    'a', 'all', 'an', 'and', 'are', 'brand', 'can', 'club', 'clubs', 'flex', 'flexes', 'for',
    'find', 'give', 'i', 'in', 'is', 'looking', 'me', 'model', 'need', 'of', 'option', 'options',
    'or', 'please', 'search', 'shaft', 'shafts', 'show', 'some', 'that', 'the', 'to', 'want', 'with'
  ]);

  const FITTING_QUESTION = /\b(?:ball speed|club speed|swing speed|handicap|slice|hook|tempo|recommend|best for me|right for me|what should i|which should i)\b/i;

  function parseWeightRange(item) {
    const numbers = weightFor(item).match(/\d{2,3}/g)?.map(Number) || [];
    if (!numbers.length) return null;
    return {
      min: Math.min(...numbers),
      max: Math.max(...numbers)
    };
  }

  function parseNaturalQuery(rawQuery) {
    let remaining = rawQuery
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/\bx[\s-]*stiff\b/g, 'x-stiff');
    const intent = {
      categories: new Set(),
      materials: new Set(),
      statuses: new Set(),
      flexes: new Set(),
      launches: new Set(),
      spins: new Set(),
      feels: new Set(),
      weight: null,
      labels: [],
      terms: [],
      fitQuestion: FITTING_QUESTION.test(rawQuery)
    };

    function addLabel(label) {
      if (!intent.labels.includes(label)) intent.labels.push(label);
    }

    function consume(pattern, callback) {
      if (!remaining.match(pattern)) return;
      callback();
      remaining = remaining.replace(pattern, ' ');
    }

    [
      [/\b(?:driving|utility)\s+irons?\b/g, 'driving_iron', 'Driving iron'],
      [/\bfairway(?:\s+woods?)?\b|\bfairway\s+metals?\b/g, 'fairway', 'Fairway wood'],
      [/\bdrivers?\b/g, 'driver', 'Driver'],
      [/\bhybrids?\b|\brescue\s+clubs?\b/g, 'hybrid', 'Hybrid'],
      [/\birons?\b/g, 'iron', 'Irons'],
      [/\bwedges?\b/g, 'wedge', 'Wedges']
    ].forEach(([pattern, value, label]) => consume(pattern, () => {
      intent.categories.add(value);
      addLabel(label);
    }));

    [
      [/\bx-stiff\b|\bextra\s+stiff\b|\bxs\b/g, 'X-Stiff', 'X-Stiff'],
      [/\b(?:ladies|lady|womens|women)\b/g, 'Ladies', 'Ladies flex'],
      [/\b(?:senior|a-flex|a flex|sr)\b/g, 'Senior', 'Senior flex'],
      [/\bregular\b|\br-flex\b|\br flex\b/g, 'Regular', 'Regular flex'],
      [/\bstiff\b|\bs-flex\b|\bs flex\b/g, 'Stiff', 'Stiff flex']
    ].forEach(([pattern, value, label]) => consume(pattern, () => {
      intent.flexes.add(value);
      addLabel(label);
    }));

    [
      [/\b(?:composite|steelfiber|steel fiber)\b/g, 'Composite', 'Composite'],
      [/\bgraphite\b/g, 'Graphite', 'Graphite'],
      [/\bsteel\b/g, 'Steel', 'Steel']
    ].forEach(([pattern, value, label]) => consume(pattern, () => {
      intent.materials.add(value);
      addLabel(label);
    }));

    consume(/\b(?:no[\s-]*upcharge|included|standard|stock)\b/g, () => {
      intent.statuses.add('stock');
      addLabel('Stock');
    });
    consume(/\b(?:premium|upcharge|custom[\s-]*order)\b/g, () => {
      intent.statuses.add('upcharge');
      addLabel('Upcharge');
    });

    [
      [/\b(?:low|lower|penetrating)[\s-]*(?:launch|launching|flight)\b/g, 'Low', 'Low launch'],
      [/\bmid(?:dle)?[\s-]*(?:launch|launching|flight)\b/g, 'Mid', 'Mid launch'],
      [/\b(?:high|higher|easy)[\s-]*(?:launch|launching|flight)\b/g, 'High', 'High launch']
    ].forEach(([pattern, value, label]) => consume(pattern, () => {
      intent.launches.add(value);
      addLabel(label);
    }));

    [
      [/\blow[\s-]*spin\b/g, 'Low', 'Low spin'],
      [/\bmid(?:dle)?[\s-]*spin\b/g, 'Mid', 'Mid spin'],
      [/\bhigh[\s-]*spin\b/g, 'High', 'High spin']
    ].forEach(([pattern, value, label]) => consume(pattern, () => {
      intent.spins.add(value);
      addLabel(label);
    }));

    [
      [/\b(?:firm|stable)\b/g, 'stable', 'Stable profile'],
      [/\b(?:active|responsive)\b/g, 'active', 'Active profile'],
      [/\bbalanced\b/g, 'balanced', 'Balanced profile']
    ].forEach(([pattern, value, label]) => consume(pattern, () => {
      intent.feels.add(value);
      addLabel(label);
    }));

    let weightMatch = remaining.match(/\b(?:between\s+)?(\d{2,3})\s*(?:-|–|to|and)\s*(\d{2,3})\s*(?:g|grams?)\b/i);
    if (weightMatch) {
      const first = Number(weightMatch[1]);
      const second = Number(weightMatch[2]);
      intent.weight = { min: Math.min(first, second), max: Math.max(first, second) };
      addLabel(`${intent.weight.min}–${intent.weight.max} g`);
      remaining = remaining.replace(weightMatch[0], ' ');
    }

    if (!intent.weight) {
      weightMatch = remaining.match(/\b(?:under|below|less than|up to|maximum(?: of)?|max(?: of)?)\s*(\d{2,3})\s*(?:g|grams?)?\b/i);
      if (weightMatch) {
        intent.weight = { max: Number(weightMatch[1]) };
        addLabel(`Under ${weightMatch[1]} g`);
        remaining = remaining.replace(weightMatch[0], ' ');
      }
    }

    if (!intent.weight) {
      weightMatch = remaining.match(/\b(?:over|above|more than|at least|minimum(?: of)?|min(?:imum)?(?: of)?)\s*(\d{2,3})\s*(?:g|grams?)?\b/i);
      if (weightMatch) {
        intent.weight = { min: Number(weightMatch[1]) };
        addLabel(`Over ${weightMatch[1]} g`);
        remaining = remaining.replace(weightMatch[0], ' ');
      }
    }

    if (!intent.weight) {
      weightMatch = remaining.match(/\b(?:around|about|approximately|approx\.?)\s*(\d{2,3})\s*(?:g|grams?)?\b/i);
      if (weightMatch) {
        const target = Number(weightMatch[1]);
        intent.weight = { min: target - 10, max: target + 10 };
        addLabel(`Around ${target} g`);
        remaining = remaining.replace(weightMatch[0], ' ');
      }
    }

    if (!intent.weight) {
      weightMatch = remaining.match(/\b(\d{2,3})\s*(?:g|grams?)\b/i);
      if (weightMatch) {
        const target = Number(weightMatch[1]);
        intent.weight = { min: target - 5, max: target + 5 };
        addLabel(`Around ${target} g`);
        remaining = remaining.replace(weightMatch[0], ' ');
      }
    }

    consume(/\b(?:light|lighter|lightweight)\b/g, () => {
      intent.weight = intent.weight || { max: 70 };
      addLabel('Lightweight');
    });
    consume(/\b(?:heavy|heavier|heavyweight)\b/g, () => {
      intent.weight = intent.weight || { min: 100 };
      addLabel('Heavier weight');
    });

    intent.terms = remaining
      .replace(/[^a-z0-9.]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter((term) => term && !SEARCH_STOP_WORDS.has(term));

    if (intent.terms.length) addLabel(`Matching “${intent.terms.join(' ')}”`);
    return intent;
  }

  function matchesNaturalQuery(item, intent) {
    const profile = profileFor(item);
    const material = materialFor(item);
    const weight = parseWeightRange(item);
    const haystack = [
      item.brand,
      item.model,
      CATEGORY_LABELS[item.category],
      item.flexes.join(' '),
      material,
      profile.launch,
      profile.spin,
      profile.feel,
      item.status,
      item.status === 'stock' ? 'included standard' : 'premium custom order',
      weightFor(item)
    ].join(' ').toLowerCase();

    return (!intent.categories.size || intent.categories.has(item.category))
      && (!intent.materials.size || intent.materials.has(material))
      && (!intent.statuses.size || intent.statuses.has(item.status))
      && (!intent.flexes.size || item.flexes.some((flex) => intent.flexes.has(flex)))
      && (!intent.launches.size || [...intent.launches].some((launch) => profile.launch.toLowerCase().startsWith(launch.toLowerCase())))
      && (!intent.spins.size || [...intent.spins].some((spin) => profile.spin.toLowerCase().startsWith(spin.toLowerCase())))
      && (!intent.feels.size || [...intent.feels].some((feel) => profile.feel.toLowerCase().includes(feel)))
      && (!intent.weight || (weight
        && (intent.weight.min == null || weight.max >= intent.weight.min)
        && (intent.weight.max == null || weight.min <= intent.weight.max)))
      && intent.terms.every((term) => haystack.includes(term));
  }

  function renderCard(item) {
    const profile = profileFor(item);
    const material = materialFor(item);
    const statusLabel = item.status === 'stock' ? 'Stock option' : 'Upcharge option';
    const image = imageFor(item);
    return `
      <article class="hw-shaft-card">
        <div class="hw-shaft-card__topline">
          <span>${escapeHtml(CATEGORY_LABELS[item.category])}</span>
          <span class="hw-shaft-card__status hw-shaft-card__status--${item.status}">${statusLabel}</span>
        </div>
        <p class="hw-shaft-card__brand">${escapeHtml(item.brand)}</p>
        <h3>${escapeHtml(item.model)}</h3>
        ${image ? `<figure class="hw-shaft-card__image"><img src="${escapeHtml(image)}" alt="${escapeHtml(`${item.brand} ${item.model} shaft reference`)}" loading="lazy" decoding="async"><figcaption>Reference image — graphics may vary by weight and flex</figcaption></figure>` : ''}
        <dl class="hw-shaft-card__specs">
          <div><dt>Material</dt><dd>${material}</dd></div>
          <div><dt>Weight</dt><dd>${weightFor(item)}</dd></div>
          <div><dt>Launch</dt><dd>${profile.launch}</dd></div>
          <div><dt>Spin</dt><dd>${profile.spin}</dd></div>
          <div><dt>Profile</dt><dd>${profile.feel}</dd></div>
          <div><dt>Flexes</dt><dd>${item.flexes.map(escapeHtml).join(' · ')}</dd></div>
        </dl>
        <div class="hw-shaft-card__context">
          <p><strong>Why Haywood offers it</strong>${whyFor(item, profile, material)}</p>
          <p><strong>Who it may suit</strong>${maySuit(profile)}</p>
        </div>
      </article>`;
  }

  function pushAnalytics(eventName, parameters) {
    window.dataLayer = window.dataLayer || [];
    const eventData = {
      event: eventName,
      page_type: 'shaft_library',
      analytics_version: '1',
      ...parameters
    };
    window.dataLayer.push(eventData);

    // The store's existing Google tag is loaded through GTM. Sending to its
    // current GA4 destination makes the custom events report immediately;
    // the dataLayer event remains available for future GTM rules.
    if (typeof window.gtag === 'function') {
      const { event, ...ga4Data } = eventData;
      window.gtag('event', eventName, {
        ...ga4Data,
        send_to: GA4_MEASUREMENT_ID
      });
    }
  }

  function analyticsState(category, material, status, state) {
    const intent = state.intent;
    return {
      shaft_category: category,
      shaft_material: material.value,
      shaft_availability: status.value,
      result_count: state.filtered.length,
      search_length: state.query.length,
      recognized_category_count: intent.categories.size,
      recognized_material_count: intent.materials.size,
      recognized_status_count: intent.statuses.size,
      recognized_flex_count: intent.flexes.size,
      recognized_launch_count: intent.launches.size,
      recognized_spin_count: intent.spins.size,
      recognized_feel_count: intent.feels.size,
      has_weight_filter: Boolean(intent.weight),
      unrecognized_term_count: intent.terms.length,
      fit_question: intent.fitQuestion
    };
  }

  function initLibrary(root) {
    const grid = root.querySelector('[data-shaft-grid]');
    const resultCount = root.querySelector('[data-shaft-result-count]');
    const total = root.querySelector('[data-shaft-total]');
    const empty = root.querySelector('[data-shaft-empty]');
    const search = root.querySelector('[data-shaft-search]');
    const material = root.querySelector('[data-shaft-material]');
    const status = root.querySelector('[data-shaft-status]');
    const searchMeaning = root.querySelector('[data-shaft-search-meaning]');
    const searchFit = root.querySelector('[data-shaft-search-fit]');
    const exampleButtons = [...root.querySelectorAll('[data-shaft-example]')];
    const categoryButtons = [...root.querySelectorAll('[data-category]')];
    let category = 'all';
    let searchTimer;
    let lastSearchSignature = '';
    let lastNoResultsSignature = '';

    total.textContent = allShafts.length;

    function render() {
      const query = search.value.trim();
      const intent = parseNaturalQuery(query);
      const filtered = intent.fitQuestion ? [] : allShafts.filter((item) => {
        const itemMaterial = materialFor(item).toLowerCase();
        return (category === 'all' || item.category === category)
          && (material.value === 'all' || itemMaterial === material.value)
          && (status.value === 'all' || item.status === status.value)
          && (!query || matchesNaturalQuery(item, intent));
      });

      grid.innerHTML = filtered.map(renderCard).join('');
      resultCount.textContent = filtered.length;
      empty.hidden = filtered.length > 0 || intent.fitQuestion;
      searchFit.hidden = !intent.fitQuestion;
      searchMeaning.hidden = !query || intent.fitQuestion;
      searchMeaning.textContent = query && !intent.fitQuestion
        ? `Understood: ${intent.labels.join(' · ') || `Matching “${query}”`}`
        : '';

      return { query, intent, filtered };
    }

    function recordSearch(state, source) {
      if (state.query.length < 3 && !state.intent.fitQuestion) return;

      const signature = [state.query, category, material.value, status.value].join('|');
      if (signature === lastSearchSignature) return;

      lastSearchSignature = signature;
      const payload = {
        ...analyticsState(category, material, status, state),
        search_source: source
      };
      pushAnalytics('shaft_library_search', payload);

      if (!state.intent.fitQuestion && state.filtered.length === 0 && signature !== lastNoResultsSignature) {
        lastNoResultsSignature = signature;
        pushAnalytics('shaft_library_no_results', payload);
      }
    }

    function scheduleSearch(state) {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => recordSearch(state, 'typed'), 800);
    }

    function recordFilter(filterType, filterValue, state) {
      pushAnalytics('shaft_library_filter', {
        ...analyticsState(category, material, status, state),
        filter_type: filterType,
        filter_value: filterValue
      });
    }

    categoryButtons.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.category;
      categoryButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      const state = render();
      recordFilter('category', category, state);
    }));
    search.addEventListener('input', () => {
      const state = render();
      scheduleSearch(state);
    });
    exampleButtons.forEach((button) => button.addEventListener('click', () => {
      search.value = button.dataset.shaftExample;
      const state = render();
      pushAnalytics('shaft_library_example', {
        ...analyticsState(category, material, status, state),
        example_number: exampleButtons.indexOf(button) + 1
      });
      recordSearch(state, 'example');
      search.focus();
    }));
    material.addEventListener('change', () => {
      const state = render();
      recordFilter('material', material.value, state);
    });
    status.addEventListener('change', () => {
      const state = render();
      recordFilter('availability', status.value, state);
    });

    root.querySelectorAll('a[href*="/pages/fitting-tool"]').forEach((link) => {
      link.addEventListener('click', () => {
        let linkLocation = 'bottom_cta';
        if (link.closest('.hw-shaft-library__hero')) linkLocation = 'hero';
        if (link.closest('[data-shaft-search-fit]')) linkLocation = 'search_prompt';
        pushAnalytics('shaft_library_fit_click', { link_location: linkLocation });
      });
    });

    render();
    pushAnalytics('shaft_library_view', { shaft_total: allShafts.length });
  }

  document.querySelectorAll('[data-shaft-library]').forEach(initLibrary);
})();
